import ExGrid from "../../../shared/Grid/ExGrid";
import ExColumn from "../../../shared/Grid/ExColumn";
import moment from "moment";

const LogOrdenTrabajo = ({ data }) => {
  const rows = (Array.isArray(data) ? data : []).map((x) => ({
    fecha: x.fechaUtc ?? x.fechaCancelacion ?? x.fechaEntrada ?? x.fechaSalida ?? null,
    motivo: x.motivo ?? "",
    accion: x.accion ?? "",
    comentarios: x.comentarios ?? "",
    usuario: (x.usuario ?? x.auditUser ?? "").toString().trim(),
  }));

  return (
    <ExGrid data={rows} style={{ maxHeight: "180px" }}>
      <ExColumn
        field={"fecha"}
        title={"Fecha"}
        cellRenderer={({ value }) =>
          value ? moment(value).format("YYYY-MM-DD hh:mm A") : ""
        }
      />
      <ExColumn field={"motivo"} title={"Motivo"} />
      <ExColumn field={"accion"} title={"Accion"} width={"2.0fr"} />
      <ExColumn field={"comentarios"} title={"Comentarios"} width={"2.0fr"} />
      <ExColumn field={"usuario"} title={"Usuario"} />
    </ExGrid>
  );
};

export default LogOrdenTrabajo;
